import { Injectable } from "@angular/core";
import { Country } from "./country";

@Injectable()
export class CountryService {
  countries: Country[];

  constructor() {}

  /**
   * Set Countries
   * @return void
   */
  setCountries(countries: Country[]) {
    this.countries = countries;
    return this;
  }

  /**
   * Return country object based on supplied country id
   * @param countryId
   * @return Country
   */
  getCountryById(countryId) {
    return this.getCountriesByIds([countryId]).shift();
  }

  /**
   * Lookup countries based on supplied ID
   * @param countryIds
   */
  getCountriesByIds(countryIds) {
    var output = [];

    this.countries.forEach((country: Country, index) => {
      /* Lookupppp */
      if (countryIds.indexOf(country.id) >= 0) output.push(country);
    });

    return output;
  }
}
